<section class="child">
    <div c-search-box search-state='read.search'></div>
</section>
<section class="child">
    <c-work-unit-filter />
</section>
<section class="child">
    <nav>
        <c-tree-explorer config="shortcutConfig"></c-tree-explorer>
    </nav>
</section>
<section class="child pretty-non-active-tags">
    <nav>
        <c-tree-explorer config="tagTreeConfig"></c-tree-explorer>
    </nav>
</section>
<section class="child">
    <nav>
        <c-tree-explorer config="processTreeConfig"></c-tree-explorer>
    </nav>
</section>